export default "__VITE_ASSET__CrnnsiYc__"